var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"elevation":"1"}},[_c('v-card-title',{staticClass:"d-flex flex-row",staticStyle:{"color":"var(--darkBlue)"}},[_c('v-row',[_c('v-col',{staticClass:"text-lg-left text-center",attrs:{"lg":"12","cols":"12"}},[_c('h3',[_vm._v(_vm._s(_vm.$t(`navigationDrawerMenu.${_vm.$attrs.key}`)))])])],1)],1),_c('v-divider'),_c('v-card-text')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }